/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */

export const LOAD_EXCEL = 'LOAD_EXCEL';
export const RESET_STATE = 'RESET_STATE';
